import React, { useEffect, useState } from 'react';
import CloseIcon from '../../images/close-block1.png';
import { Button, Input } from 'antd';
import { Alert } from './utility';
const FlagTip = (param) => {
    const [textValue, setTextValue] = useState('')
    useEffect(() => {
        document.body.style.overflow = "hidden";
        setTextValue('')
        return () => {
            document.body.style.overflow = "auto";
            setTextValue('')
        }
    }, [])
    return <div className="platform-pop-up">
        <div className="flag-script-box">
            <div className="script-title">
                请输入题目文本
                {/* <img src={CloseIcon} alt="" onClick={param.onClose} /> */}
            </div>
            <div className="script-content">
                <Input.TextArea
                    style={{ minHeight: '200px' }}
                    value={textValue}
                    onChange={(e) => setTextValue(e.target.value)}
                    placeholder='攻击者要成功利用 CVE‑2021‑21978，需要满足什么前提？
A. 必须获取管理员密码
B. 必须登录至系统后台
C. 仅需网络可访问 View Planner Appliance
D. 需要本地物理访问权限

答案：C
解析：CVE-2021-21978 属于未授权远程代码执行漏洞。该漏洞源于 VMware View Planner Appliance 中部分配置相关接口缺乏有效的身份认证与访问控制。'
                />
                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                    <Button
                        style={{ margin: '0 20px' }}
                        onClick={param.onClose}
                    >
                        取消
                    </Button>
                    <Button
                        type='primary'
                        style={{ margin: '0 20px' }}
                        onClick={() => {
                            if (!textValue) {
                                Alert('warn', '请输入题目文本')
                            }
                            param.onAnalysis(textValue)
                        }}
                    >
                        确定
                    </Button>
                </div>
            </div>
        </div>
    </div >
}
export default FlagTip;